// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.consent[data-v-3c0e98db] {\n  color: #e53935;\n}\n.registration-form[data-v-3c0e98db] {\n  width: 100%;\n}\nlabel[data-v-3c0e98db] {\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
